"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.App = void 0;
var _i18n = require("@ori/i18n");
var _logger = require("@ori/logger");
var _shoppingContext = require("@ori/shopping-context");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _Summary = require("./components/Summary");
var _skeleton = require("./components/skeleton");
var _constants = require("./constants");
var _logger2 = require("./logger");
var _types = require("./types");
var _jsxRuntime = require("react/jsx-runtime");
const App = (props)=>{
    const { getTestId } = (0, _testidGenerator.default)();
    const { isLoading, isLoaded, shoppingContext } = (0, _shoppingContext.useShoppingContext)();
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.LoggerProvider, {
        logger: _logger2.mainLogger,
        children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_logger.ErrorBoundary, {
            areaName: "".concat(_constants.APP_NAME, "-boundary"),
            children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_i18n.TranslationsNamespaceProvider, {
                namespace: _constants.translationsNamespace,
                children: isLoading || !isLoaded || !shoppingContext ? /*#__PURE__*/ (0, _jsxRuntime.jsx)(_skeleton.SummarySkeleton, {
                    "data-testid": getTestId(_types.TestId.SummarySkeleton)
                }) : /*#__PURE__*/ (0, _jsxRuntime.jsx)(_Summary.Summary, {
                    shoppingContext: shoppingContext,
                    ...props
                })
            })
        })
    });
};
exports.App = App;
